export const BRAND_NAME = 'ShuffleLuck9';
// Note: It is the main site url. Ex - sky11.com, etc.
export const BRAND_DOMAIN = 'shuffleluck9.in';
export const PROVIDER_ID = 'BetFair';
